import React from "react";
import { motion } from "framer-motion";
import {
  FaBookOpen,
  FaEnvelope,
  FaQuestionCircle,
  FaUserShield,
  FaHandsHelping,
} from "react-icons/fa";

const HelpCenter = () => {
  const supportOptions = [
    {
      title: "Course Guidance",
      description:
        "Get help with enrolling, accessing, and navigating your courses.",
      icon: <FaBookOpen className="text-indigo-500 text-4xl" />,
    },
    {
      title: "Account & Security",
      description: "Assistance with account settings, security, and privacy.",
      icon: <FaUserShield className="text-green-500 text-4xl" />,
    },
    {
      title: "Payments & Refunds",
      description: "Learn more about payment methods and refund policies.",
      icon: <FaHandsHelping className="text-yellow-500 text-4xl" />,
    },
    {
      title: "FAQs",
      description: "Find quick answers to our most common questions.",
      icon: <FaQuestionCircle className="text-purple-500 text-4xl" />,
    },
    {
      title: "Contact Support",
      description:
        "Reach out to our team directly for personalized assistance.",
      icon: <FaEnvelope className="text-pink-500 text-4xl" />,
    },
  ];

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center p-6"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1600891964599-f61ba0e24092?auto=format&fit=crop&w=1470&q=80')",
      }}
    >
      <div className="bg-white bg-opacity-90 backdrop-blur-lg rounded-3xl shadow-2xl w-full max-w-5xl p-10">
        <motion.h1
          className="text-4xl md:text-5xl font-bold text-center text-indigo-600 mb-6"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          🛟 Help Center
        </motion.h1>

        <motion.p
          className="text-center text-gray-600 mb-10 max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.7 }}
        >
          We’re here to help! Find answers, get guidance, and connect with our
          support team for anything you need on Vicademics.
        </motion.p>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {supportOptions.map((option, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-xl shadow-lg p-6 flex flex-col items-center text-center hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.15 }}
              whileHover={{ scale: 1.05 }}
            >
              {option.icon}
              <h3 className="text-xl font-semibold mt-4 mb-2 text-gray-800">
                {option.title}
              </h3>
              <p className="text-gray-600 text-sm">{option.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
